import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ViewListIcon from '@mui/icons-material/ViewList';
import { string } from 'prop-types';

const DataNeededEmptyCard = ({ title, subtitle }) => (
  <Stack
    sx={{
      alignItems: 'center',
      backgroundColor: 'graphic.lighter',
      marginLeft: { lg: '395px' },
      // eslint-disable-next-line sort-keys-fix/sort-keys-fix
      height: { xs: 255, lg: 155 },
      justifyContent: 'center',
      // eslint-disable-next-line sort-keys-fix/sort-keys-fix
      mt: { xs: 2, lg: 8 },
      p: 3,
    }}
  >
    <ViewListIcon sx={{ color: 'graphic.icons', height: 38, mb: 1, width: 38 }} />
    <Typography
      sx={{
        color: 'text.secondary',
        fontWeight: 400,
        textAlign: 'center',
      }}
      variant="h6"
    >
      {title}
    </Typography>
    <Typography sx={{ color: 'text.secondary', textAlign: 'center' }} variant="body1">
      {subtitle}
    </Typography>
  </Stack>
);

DataNeededEmptyCard.propTypes = {
  subtitle: string.isRequired,
  title: string.isRequired,
};

export default DataNeededEmptyCard;
